/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { SearchRoot } from '../components/SearchRoot';

export const SearchRootWithExperiment = () => (
  <React.Fragment>
    {/* We need to add the Experiment Element in order to register in Analytics */}
    <SearchRoot />
  </React.Fragment>
);

export { SearchRootWithExperiment as SearchRootContainer };
